import { NotificationsService } from 'angular2-notifications';
import { Component, OnInit } from '@angular/core';
import { CartService } from '../services/cart.service';

@Component({
  selector: 'app-cart-list-finished',
  templateUrl: './cart-list-finished.component.html'
})
export class CartListFinishedComponent implements OnInit {

  private cartsLoading: Boolean = true;
  public carts: any;

  constructor(
    private cartService: CartService,
    private notificationsService: NotificationsService
  ) { }

  ngOnInit() {
    this.loadCarts();
  }

  loadCarts(){
    this.cartsLoading = true;
    this.carts = [];
    this.cartService.getAllCarts(false).subscribe(
      (response) => {
        this.carts = response.data.carts;
        this.cartsLoading = false;
      },
      (error) => {
        this.notificationsService.success('Ups!', 'Błąd przy pobieraniu listy koszyków');
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/cart/cart-list-finished.component.ts